export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        record_type: "Record Type",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      delete_confirm: {
        title: 'Delete "%{name}"?',
        content: "%{name} has %{linked}. They will be kept with no company.",
        and: "and",
      },
      notifications: {
        deleted_kept: "Company deleted. Deals and contacts remain.",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
        new_company: "+ New company",
      },
      quick_create: {
        title: "New company",
        description:
          "The website gives the company its logo and stops it being added twice.",
        exists: "%{name} is already in the CRM.",
        use_existing: "Use %{name}",
        create_anyway: "Create anyway",
        create: "Create company",
      },
      filters: {
        only_mine: "Only companies I manage",
        record_type: "Record Type",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      // The Contact page's task section. The key keeps the old name; the copy
      // does not. One record, one word: "task" (Sam, 2026-09-16). LCATOMICZO-31.
      action_items: {
        title: "Tasks",
        everyone: "Everyone",
        mine: "Mine",
        empty_everyone: "No open tasks about this contact.",
        empty_mine: "None assigned to you.",
        add: "Add",
        add_first: "Add a task",
        view_all: "View all (%{smart_count})",
        show_fewer: "Show fewer",
        load_error: "Couldn't load tasks.",
        truncated: "Showing the first 100.",
        // Done tasks stay on the contact, under the open ones. LCCRM-86.
        completed: "Completed (%{smart_count})",
      },
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email: "Email",
        phone: "Phone",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        record_type: "Record Type",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV or vCard",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure you provided a valid CSV or vCard (.vcf) file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV or vCard (.vcf) file",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      approvals: {
        title: "Needs approval",
        description: "New contacts received from Loops",
        review: "Review",
        review_contact: "Review contact",
        no_pending: "No contacts waiting for approval",
        pending_badge:
          "One contact needs approval |||| %{smart_count} contacts need approval",
        loading_error: "Could not load contact approvals",
        approve: "Approve contact",
        approve_all: "Approve all",
        approve_all_title: "Approve all pending contacts?",
        approve_all_description:
          "One contact will be added to CRM as-is with their Loops data. |||| %{smart_count} contacts will be added to CRM as-is with their Loops data.",
        approve_all_confirm: "Approve one |||| Approve all %{smart_count}",
        approving: "Approving...",
        reject: "Reject",
        rejecting: "Rejecting...",
        reject_title: "Reject this contact?",
        reject_description:
          "This contact will stay out of CRM if Loops sends it again. Nothing will be changed in Loops.",
        notifications: {
          approved: "Contact approved and added to CRM",
          linked: "Approval linked to the existing CRM contact",
          rejected: "Contact rejected",
          bulk_approved:
            "One contact approved |||| %{smart_count} contacts approved",
          bulk_partial: "%{ok} approved, %{failed} failed.",
          changed: "This contact was already reviewed. The list has refreshed.",
          error: "Could not review this contact",
        },
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        record_type: "Record Type",
        loops: "Loops",
        loops_linked: "Linked to Loops",
        loops_not_linked: "Not linked to Loops",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
      no_company: "No company",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
        uploading_image: "Uploading image…",
        image_upload_failed: "Couldn't upload the image. Try pasting it again.",
        image_uploading_wait: "Wait for the image to finish uploading",
      },
      channel: {
        placeholder: "Channel",
        new_title: "New channel",
        manage: "Manage channels",
        create: "Create channel",
        name: "Channel name",
        name_placeholder: "For example WhatsApp",
        color: "Color",
        no_color: "No color",
        shade: "Shade",
        duplicate: "A channel with this name already exists",
        save_error: "Couldn't save the channel. Try again.",
        delete_error: "Couldn't delete the channel",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
        role: "Role",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
        done_editing: "Done",
      },
      inline_save: {
        pending:
          "%{smart_count} unsaved change |||| %{smart_count} unsaved changes",
        success: "Users updated",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        due_short: "due",
        contact_id: "Contact",
      },
      // The row line beside "from <meeting>". The contact's avatar already says
      // what the name is, so the name carries it on its own. LCATOMICZO-31.
      contact_line: "%{name}",
      // A task from a confidential meeting the reader cannot see. LCCRM-93.
      restricted_meeting: {
        source: "from a restricted meeting",
        heading: "From a restricted meeting",
        no_access:
          "You don't have access to this meeting's recording or transcript.",
      },
      due: {
        today: "today",
        tomorrow: "tomorrow",
        in_days: "in %{smart_count} day |||| in %{smart_count} days",
        overdue: "%{smart_count} day overdue |||| %{smart_count} days overdue",
      },
      collaboration: "Collaboration",
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
      },
      sheet: {
        edit: "Edit task",
      },
      empty: "No tasks yet",
      // This list is filtered to the current user (TasksListByDueDate), so the
      // hint says whose. The old copy, "Tasks added to your contacts will appear
      // here", predates v1.7.0, when a task belonged to a contact; it described
      // a filter this list has never had. LCATOMICZO-31.
      empty_list_hint: "Tasks assigned to you appear here.",
      filters: {
        later: "Later",
        no_due_date: "No due date",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
      },
      updated: "Task updated",
    },
    // The tasks list page. The resource key stays `action_items`; the label the
    // user reads is "Tasks", matching the mobile navigation, the mobile list
    // heading and the Settings section, which all read `resources.tasks.name`.
    // Those disagreed before. LCATOMICZO-31.
    action_items: {
      name: "Tasks",
      filters: {
        search: "Search tasks...",
        category: "Category",
        status: "Status",
        all: "All",
        open: "Open",
        done: "Done",
        source: "Source",
        from_meeting: "From meeting",
        manual: "Manual",
        assignee: "Assignee",
        // The record type of the contact a task is about. LCCRM-86.
        contact_record_type: "Contact record type",
      },
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        duplicate_name:
          "A tag with this name already exists, whatever the capitalisation",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
    zoom_meetings: {
      name: "Zoom Meeting |||| Zoom Meetings",
      fields: {
        meeting_start_time: "Date",
        meeting_topic: "Topic",
        meeting_host_email: "Host",
        attendees: "Attendees",
        tasks: "Tasks",
        status: "Status",
        content: "Content",
        permission: "Permission",
      },
      // Confidential meetings. LCCRM-93.
      permission: {
        title: "Who can see this meeting",
        everyone: "Everyone",
        restricted: "Restricted",
        only_these: "Only these people",
        admins_note: "Admins always see every meeting.",
        admin_always: "(admin, always sees it)",
        error: "Couldn't change who can see the meeting.",
      },
      assets: {
        screen: "Screen recording",
        camera: "Camera video",
        audio: "Audio",
        transcript: "Transcript",
        summary: "Summary",
      },
      asset_state: {
        available: "available",
        processing: "uploading",
        failed: "upload failed",
        waiting: "waiting for Zoom",
        none: "none",
      },
      waiting_for_zoom: "Waiting for Zoom",
      assets_lower: {
        screen: "screen recording",
        camera: "camera video",
        audio: "audio",
        transcript: "transcript",
        summary: "summary",
        recording: "recording",
      },
      asset_message: {
        waiting:
          "Waiting for the %{asset} from Zoom. This usually takes about 15 minutes, and the page updates on its own.",
        processing: "The %{asset} is uploading. The page updates on its own.",
        failed: "The %{asset} upload failed.",
        none: "This meeting has no %{asset}.",
      },
      asset_actions: {
        play: "Play",
        show: "Show",
        download: "Download",
        open_dropbox: "Open in Dropbox",
        copy_dropbox: "Copy Dropbox link",
        copy_atomic: "Copy Atomic link",
      },
      transcript_search: {
        found: "Found in transcript",
        found_summary: "Found in summary",
        capped:
          "Transcript and summary matches are limited to the 200 most recent meetings.",
        said_at: "Open the meeting at %{time}",
        open_summary: "Open the meeting on its %{label} summary",
      },
      asset_notify: {
        dropbox_copied: "Dropbox link copied",
        atomic_copied: "Atomic link copied",
      },
      review: {
        remaining: "%{smart_count} left |||| %{smart_count} left",
      },
      filters: {
        search: "Search topic, people, transcripts, summaries...",
        host: "Host",
        my_meetings: "My meetings",
        no_host: "No host",
        has_summary: "Summary",
        screen_recording: "Screen recording",
        camera_video: "Camera video",
        audio: "Audio",
        has_transcript: "Transcript",
        has_tasks: "Tasks",
        with_content: "With content",
        date: {
          any: "Any date",
          today: "Today",
          this_week: "This week",
          this_month: "This month",
          last_30_days: "Last 30 days",
          older: "Older",
          from: "From %{date}",
          until: "Until %{date}",
          clear: "Clear dates",
        },
      },
    },
    zoom_meeting_summaries: {
      name: "Zoom Meeting |||| Zoom Meetings",
      external_hidden: "External — hidden",
      action: {
        process: "Create all remaining",
        reparse_tasks: "Re-parse tasks",
      },
      fields: {
        meeting_id: "Meeting ID",
        meeting_topic: "Topic",
        meeting_start_time: "Date",
        summary_title: "Summary Title",
        summary_content: "Summary",
        status: "Status",
        company_id: "Company",
        deal_id: "Deal",
        assignee_name: "Assignee",
        text: "Task description",
        tasks: "Tasks",
        type: "External",
      },
      status: {
        pending: "Pending",
        done: "Done",
      },
    },
  },
  crm: {
    // The Bookmarks section on contact and company pages. LCATOMICZO-83.
    bookmarks: {
      title: "Bookmarks",
      add: "Add",
      url: "Link or phone",
      url_placeholder: "A link, or a phone like +1 415 555 0123",
      name: "Name",
      save: "Save bookmark",
      cancel: "Cancel",
      edit: "Edit bookmark",
      remove: "Remove bookmark",
      confirm_remove: "Remove?",
      goes_under: "Goes under",
      empty:
        "No bookmarks yet. Paste any link, or type a phone number for WhatsApp.",
      duplicate: "Already saved as “%{label}”.",
      invalid_url:
        "That isn't a web link. Paste an address starting with https://",
      no_country_code: "Add the country code, e.g. +1 415 555 0123",
      save_failed: "Couldn't save the bookmark. Try again.",
      not_a_link: "Not a web link, so it can't be opened.",
      platforms: {
        linkedin: "LinkedIn",
        gmail: "Gmail",
        whatsapp: "WhatsApp",
        other: "Other",
      },
    },
    action: {
      reset_password: "Reset Password",
      create_item: "Create %{item}",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google: "Continue with Google",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
      back_to_list: "Back to list",
    },
    filters: {
      filtered_by: "Filtered by",
      none: "No filters",
      clear_all: "Clear all",
      remove: "Remove filter: %{label}",
      search: "“%{term}”",
    },
    loops: {
      linked: "Contact linked to Loops",
      link_failed: "Failed to link contact to Loops",
      linked_count: "Linked %{count} contact(s) to Loops",
      link_partial: "Linked %{ok}, %{failed} failed",
      none_to_link: "No unlinked contacts to link",
    },
    plane: {
      pushed: "Pushed to Plane",
      push_failed: "Failed to push to Plane",
      pushed_count: "Pushed %{count} task(s) to Plane",
      push_partial: "Pushed %{ok}, %{failed} failed",
      no_dev: "No dev tasks to push",
      assignee_not_on_plane:
        "%{user} isn't on Plane yet — create their account, then push again",
      // A push runs with the pusher's own Plane key, so Plane shows them as the
      // creator. LCCRM-92.
      no_key: "Add your Plane API key in your profile to push to Plane",
      key_rejected:
        "Plane rejected your API key. Update it in your profile, then push again",
      not_synced_no_key: "Not synced to Plane, add your Plane API key",
      not_synced_key_rejected:
        "Not synced to Plane, your Plane API key was rejected",
      push_to_plane: "Push to Plane",
      go_to_plane: "Go to Plane",
      key: {
        title: "Plane",
        description:
          "Tasks you push to Plane are created with your own key, so Plane shows you as their creator. In Plane, open Profile settings, then Personal Access Tokens, to create one.",
        label: "Plane API key",
        placeholder: "Paste your Plane API key",
        connect: "Connect",
        connected_as: "Connected as %{email}",
        connected: "Connected",
        replace: "Replace",
        remove: "Remove",
        remove_confirm:
          "Remove your Plane API key? You won't be able to push tasks to Plane until you add one again.",
        saved: "Plane key connected",
        removed: "Plane key removed",
        error_rejected:
          "Plane rejected this key. Check that you copied all of it.",
        error_not_member:
          "This Plane account isn't a member of the %{project} project. Ask to be added, then try again.",
        error_unavailable: "Couldn't reach Plane to check this key. Try again.",
        error_generic: "Couldn't save the key. Try again.",
        unavailable: "Plane isn't set up for this workspace.",
      },
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_note_about_company: "%{name} added a note about company",
      you_added_note_about_company: "You added a note about company",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
      recent_client_calls: "Recent Client Calls",
      no_recent_calls: "No client calls yet.",
      action_items: "Tasks & Feedback",
      no_action_items: "No open tasks.",
      see_all: "See all",
    },
    header: {
      import_data: "Import data",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      // The settings icon beside something Settings configures. LCCRM-86.
      edit_section: "Edit %{name}",
      app_title: "App Title",
      record_types: {
        help: "Used by both contacts and companies.",
        types: "Types",
      },
      sections: {
        branding: "Branding",
        general: "General",
        note_statuses: "Note Statuses",
        note_channels: "Note Channels",
        record_types: "Record Types",
        tags: "Tags",
        whitelist: "Signup Whitelist",
      },
      channels: {
        description:
          "Where a note's conversation happened. Pick one when writing a note; notes saved by the inbound email link get Email on their own.",
        usage: "%{smart_count} note |||| %{smart_count} notes",
        edit: "Edit %{name}",
        delete: "Delete %{name}",
        delete_title: 'Delete "%{name}"?',
        delete_content:
          "%{smart_count} note has this channel. It keeps its text and loses the channel. |||| %{smart_count} notes have this channel. They keep their text and lose the channel.",
        delete_content_unused: "No note has this channel.",
        delete_content_unknown:
          "Notes that have this channel keep their text and lose the channel.",
      },
      tags: {
        description:
          "Tags you create here are available on every contact. Deleting one removes it from the contacts that carry it.",
        usage: "%{smart_count} contact |||| %{smart_count} contacts",
        empty: "No tags yet.",
        delete_title: 'Delete "%{name}"?',
        delete_content:
          "This removes the tag from %{smart_count} contact. It cannot be undone. |||| This removes the tag from %{smart_count} contacts. It cannot be undone.",
        delete_content_unused:
          "No contact carries this tag. It cannot be undone.",
        delete_content_unknown:
          "This removes the tag from every contact that carries it. It cannot be undone.",
      },
      whitelist: {
        description:
          "Control which emails or domains can sign up via Google OAuth.",
        type_email: "Email",
        type_domain: "Domain",
        invalid_email: "Invalid email format",
        no_at_prefix: "Enter bare domain (e.g. example.com), not @example.com",
        duplicate: "This entry already exists",
        empty: "No entries. All Google signups are currently allowed.",
        domain_hint: "Enter bare domain (e.g. example.com), not @example.com",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
